import { MovementOffsetDTO } from '../DTOs/MovementOffsetDTO';

export class MovementOffset {
  public static fromDTO(movementOffsetDTO: MovementOffsetDTO) {
    return new MovementOffset(movementOffsetDTO.value, movementOffsetDTO.direction);
  }

  private _value: number;
  private _direction: boolean;

  // Getter for the _value field
  public get value(): number {
    return this._value;
  }

  // Getter for the _direction field
  public get direction(): boolean {
    return this._direction;
  }

  constructor(value: number, direction: boolean) {
    this._value = value;
    this._direction = direction;
  }

  public toDTO() {
    return new MovementOffsetDTO(this._value, this._direction);
  }
}
